var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-wrap" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "用户名称", size: "small", prop: "userName" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.userName,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "userName", $$v)
                  },
                  expression: "ruleForm.userName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "所属机构", size: "small", prop: "affiliation" }
            },
            [
              _c("org-select", {
                attrs: {
                  multiple: true,
                  rootOrgId: _vm.topId,
                  modal: false,
                  placeholder: "请选择拟稿部门"
                },
                model: {
                  value: _vm.ruleForm.affiliation,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "affiliation", $$v)
                  },
                  expression: "ruleForm.affiliation"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "职位", size: "small", prop: "position" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.position,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "position", $$v)
                  },
                  expression: "ruleForm.position"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "联系方式", size: "small", prop: "information" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.information,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "information", $$v)
                  },
                  expression: "ruleForm.information"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "角色状态", size: "small", prop: "status" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.status,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "status", $$v)
                  },
                  expression: "ruleForm.status"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "核心机构号",
                size: "small",
                prop: "coreOrgNumber"
              }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.coreOrgNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "coreOrgNumber", $$v)
                  },
                  expression: "ruleForm.coreOrgNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "机构编号", size: "small", prop: "orgNumber" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.orgNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "orgNumber", $$v)
                  },
                  expression: "ruleForm.orgNumber"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "dialog-footer" }, [
            _c("input", {
              staticClass: "btn",
              attrs: { type: "button", value: "取消" },
              on: { click: _vm.cancelFn }
            }),
            _c("input", {
              staticClass: "btn btn-red",
              attrs: { type: "button", value: "确认" },
              on: {
                click: function($event) {
                  return _vm.submitForm("ruleForm")
                }
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }